<div class="rod-modal-content">
	<div class="rod-modal">
		<div class="close-button" (click)="closeModal()">
			<img src="/assets/icons/svg/close-modal.svg" alt="Fechar modal" loading="lazy" />
		</div>
		<div class="title">
			@if (!observation) {
				<h1>Observaciones asesor comercial</h1>
			}
			@if (observation) {
				<h1>Observaciones</h1>
			}
		</div>

		<div class="textarea-container">
			<textarea [(ngModel)]="requoteDescription" placeholder="Describa el motivo de la recotización" [disabled]="observation!.length > 0 ? true : false"></textarea>
		</div>
		<div class="content">
			<ng-content></ng-content>
		</div>
		@if (!observation) {
			<div class="d-flex ms-2" style="justify-content: space-around">
				<button class="btn btn-primary" (click)="requestRequotation()">Solicitar cotización</button>
			</div>
		}
	</div>
</div>
